<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title mb-3">
        {{ $t("edit") }} {{ $tc("currency_conversion", 2) }}
      </div>
      <router-link class="btn-blue" to="currencies-conversion"
        >{{ $tc("currency_conversion", 2) }} {{ $tc("list", 2) }}</router-link
      >
    </div>
    <div class="white-wrapper">
      <form class="row">
        <div
          v-for="(item, index) in Currencies"
          :key="index"
          v-if="item.fieldname !== 'ccr_id' && item.fieldname !== 'curr_name'"
          class="col-lg-6 col-xl-3 align-self-center mb-4"
        >
          <div
            v-if="
              item.type !== 'radio' &&
              item.type !== 'dropdown' &&
              item.type !== 'date'
            "
          >
            <div class="d-flex align-items-center">
              <div class="input-material">
                <input
                  @focus="onFocusHandler"
                  :type="item.type"
                  :name="item.fieldname"
                  :id="item.fieldname"
                  v-validate="item.validation"
                  v-model="item.fieldvalue"
                  placeholder="."
                  v-b-tooltip.hover.top="$t(item.tooltip)"
                />
                <label>{{ $tc(item.label, 1) }}</label>
              </div>
              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <!-- {{ item.fieldname }} -->
              <span v-if="submitted && errors.has(item.fieldname)">{{
                $t(item.errormsg)
              }}</span>
            </p>
          </div>

          <div v-if="item.type === 'radio'">
            <div class="d-flex align-items-center min-height-50">
              <label class="mb-0 mr-3">{{ $t("active") }}</label>
              <!-- <label class="ios-switch"> -->
              <b-form-checkbox
                type="checkbox"
                class="j-checkbox"
                v-model="item.fieldvalue"
              />
              <!-- <span class="switch-slider"></span>
              </label> -->
            </div>
            <p class="error_message">
              <!-- {{ item.fieldname }} -->
              <span></span>
            </p>
          </div>

          <div v-if="item.type === 'dropdown'">
            <div v-if="item.fieldname === 'currency_id'">
              <div class="d-flex align-items-center">
                <div class="dropdown-curve-container">
                  <label
                    :class="item.dropdownSelected.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <b-dropdown
                    :text="item.dropdownSelected"
                    variant="dropdown-curve"
                    class="w-100"
                    v-b-tooltip.hover.top="$t(item.tooltip)"
                  >
                    <b-dropdown-item
                      v-for="(dropdownItem, dropdownIndex) in currency_list"
                      :key="dropdownIndex"
                      href="#"
                      @click="
                        onDropdownChange(
                          $event,
                          item.label,
                          dropdownItem,
                          index
                        )
                      "
                      >{{ dropdownItem.curr_name }}</b-dropdown-item
                    >
                  </b-dropdown>
                </div>

                <!-- <Tooltip :title="$t(item.tooltip)" /> -->
              </div>
              <p class="error_msg">
                <span v-if="submitted && item.dropdownSelected.length == 0">{{
                  msgcountry
                }}</span>
              </p>
            </div>
          </div>

          <div v-if="item.type === 'date'">
            <div class="d-flex align-items-center">
              <div class="input-material">
                <div class="add-datepicker">
                  <button
                    class="btn-clearDate"
                    v-if="item.fieldvalue"
                    v-on:click.prevent.stop="clearSelectedDate()"
                  >
                    ✖
                  </button>
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    :type="item.type"
                    :name="item.fieldname"
                    :id="item.fieldname"
                    v-validate="item.validation"
                    v-model="item.fieldvalue"
                    :typeable="true"
                    v-b-tooltip.hover.top="$t(item.tooltip)"
                  ></Datepicker>
                  <label
                    :class="typeof item.fieldvalue === 'object' ? 'active' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  >
                  <!-- <label
                    :class="item.fieldvalue.length > 0 ? 'shift-up' : ''"
                    >{{ $tc(item.label, 1) }}</label
                  > -->
                </div>
              </div>

              <!-- <Tooltip :title="$t(item.tooltip)" /> -->
            </div>
            <p class="error_message">
              <span v-if="submitted && errors.has(item.fieldname)">
                {{ $t(item.errormsg) }}</span
              >
            </p>
          </div>
        </div>

        <div class="col-md-12 text-center mt-4">
          <button
            :disabled="btenable"
            @click.prevent.stop="onUpdateHandler"
            class="btn-blue"
          >
            {{ $t("update") }}
          </button>

          <b-button
            class="btn-outline-grey"
            variant="default"
            to="currencies-conversion"
            >{{ $t("cancel") }}</b-button
          >
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";
import CurrenciesConversion from "@/helper/formJSONMaster/CurrenciesConversion";
import checkListCategoriesVue from "../CheckListCategoriesComponents/checkListCategories.vue";

export default {
  data() {
    return {
      btenable: false,
      Currencies: CurrenciesConversion.m_currency_conversion_rate_to_base,

      Methods: CurrenciesConversion.Methods,
      submitted: false,
      currency_list: [],
    };
  },
  beforeMount() {
    this.getCurrencyList();
    // console.log("this.$route.query :", this.$route.query);
    const { id } = this.$route.query;
    if (id) {
      this.getEditList(id);
    } else {
      this.$router.go(-1);
    }
  },
  mounted() {},
  methods: {
    clearSelectedDate: function () {
      this.Currencies[3].fieldvalue = "";
    },
    onResetForm: function () {
      this.Currencies.map((x) => {
        if (x.type === "text" || x.type === "date") {
          x.fieldvalue = "";
        } else if (x.type === "radio") {
          x.fieldvalue = true;
        }
      });
    },
    getCurrencyList: function () {
      let body = this.getRequestBody("GET", undefined, {
        GET: "/admin/",
        tableName: "ms_currencies",
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.currency_list = data.Records;
          } else {
            console.log("show error1 :", data.message);
          }
        })
        .catch((error) => {
          console.log("show error2 :", error);
        });
    },
    onFocusHandler: function () {
      // this.submitted = false;
    },
    onDropdownChange: function (event, type, item, mainIndex) {
      this.Currencies[mainIndex].fieldvalue = item.curr_id;
      this.Currencies[mainIndex].dropdownSelected = item.curr_name;
    },
    getEditList: function (id) {
      // let params = `id`
      let body = this.getRequestBody("GET", undefined, {
        ...this.Methods,
        params: { id },
      });
      MasterService.GlobalRequest(body)
        .then((response) => {
          const { data } = response;
          if (data.status) {
            console.log("data :");
            let obj = data.details[0];
            this.Currencies.map((x) => {
              if (x.fieldname === "ccr_is_active") {
                x.fieldvalue = obj[x.fieldname] === "Y" ? true : false;
              } else if (x.type === "date") {
                //x.fieldvalue = this.formatDate(obj[x.fieldname]);
                x.fieldvalue = new Date(obj[x.fieldname]);
              } else {
                x.fieldvalue = obj[x.fieldname];
              }
            });
            this.Currencies[2].fieldvalue = obj.curr_id;
            this.Currencies[2].dropdownSelected = obj.curr_name;
          } else {
            // Show Errors
            console.log("show error :", data.message);
          }
        })
        .catch((error) => {
          // Show Catch Error
          console.log("show error :", error);
        });
    },
    onUpdateHandler: function () {
      // let body = this.getRequestBody("PUT", this.Currencies, {
      //   ...this.Methods,
      //   params: { id: this.$route.query.id }
      // });
      // MasterService.GlobalRequest(body)
      //   .then(response => {
      //     const { data } = response;
      //     if (data.status) {
      //       console.log("here :", data);
      //       this.$router.push({
      //         path: "/master/currencies"
      //       });
      //     } else {
      //       console.log("show error :", data.message);
      //     }
      //   })
      //   .catch(error => {
      //     console.log("show error :", error);
      //   });
      this.submitted = true;
      this.$validator.validate().then((valid) => {
        console.log("valid :", valid);
        if (valid) {
          if (this.Currencies[2].fieldvalue == "") {
            return false;
          }
          this.btenable = true;
          console.log("valid :", valid);
          let body = this.getRequestBody("PUT", this.Currencies, {
            ...this.Methods,
            params: { id: this.$route.query.id },
          });
          console.log("body :", body);

          MasterService.GlobalRequest(body)
            .then((response) => {
              this.btenable = false;
              const { data } = response;

              if (data.status) {
                console.log("here :", data);
                this.$router.push({
                  path: "/master/currencies-conversion",
                });
              } else {
                console.log("show error :", data.message);
                this.$toasted.show(Error(data.message));
              }
            })
            .catch((error) => {
              console.log("show error2 :", error);
            });
        } else {
          console.log("else :");
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CurrencyConversionComponents/editCurrencyConversion.vue